export const twoOneFormStyle = {
  layout: {
    labelCol: {span: 8},
    wrapperCol: {span: 16},
  },
  tailLayout: {
    wrapperCol: {offset: 8, span: 16},
  }
};